import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { useFragment, graphql } from 'react-relay';
import { Link } from 'dibs-elements/exports/Link';
import { getDisplayLocation } from '../shared/helpers/getDisplayLocation';

import styles from './ProjectHeader.scss';

import type { ProjectHeader_searchResult$key } from './__generated__/ProjectHeader_searchResult.graphql';

type Props = {
    searchResult: ProjectHeader_searchResult$key | null;
};

const ProjectHeader: FC<Props> = props => {
    const { searchResult: searchResultRef } = props;

    const searchResult = useFragment(
        graphql`
            fragment ProjectHeader_searchResult on TradeInteriorProjectQueryOutput {
                project {
                    name
                    type {
                        label
                    }
                    address {
                        city
                        state
                        country
                        zipCode
                    }
                }
                firm {
                    name
                    publicProfile {
                        urlLabel
                    }
                }
            }
        `,
        searchResultRef
    );

    const project = searchResult?.project;
    const name = project?.name || '';
    const projectType = project?.type?.label || '';
    const address = project?.address;
    const location = address ? getDisplayLocation(address) : '';

    const firm = searchResult?.firm;
    const firmUrlLabel = firm?.publicProfile?.urlLabel || '';
    const firmName = firm?.name || '';

    return (
        <>
            <h1 className={styles.title} data-tn="project-title">
                {name}
            </h1>
            <div className={styles.subtitle} data-tn="project-subtitle">
                <FormattedMessage
                    id="abt.interiorProject.header.descriptor"
                    defaultMessage="{projectType} by {link} in {location}"
                    values={{
                        projectType,
                        link: <Link href={`/design-firms/${firmUrlLabel}/`}>{firmName}</Link>,
                        location,
                    }}
                />
            </div>
        </>
    );
};

export default ProjectHeader;
